import {fade} from "@material-ui/core/styles";
import {titleColor} from "../constants";

const styles = theme => ({
    root: {
        height: "calc(100% - 70px)"
    },
    elements: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        paddingTop: "70px",
        backgroundColor: fade(titleColor, 0.1),
        [theme.breakpoints.up("sm")]: {
            height: "100%",
        },
    },
    textElements: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        paddingBottom: "57px",
        [theme.breakpoints.up("sm")]: {
            height: "100%",
        },
    },
    footer: {
        width: "100%",
        height: "57px",
        justifySelf: "flex-end",
    },
});

export default styles